import { StyleSheet, Platform, useWindowDimensions } from 'react-native'
import { useMemo } from 'react'
import { stdCouleurBleu } from '@commonStyle';

// Hook pour les styles dynamiques (réactif au redimensionnement)
export const useProfilStyles = () => {
  const { width } = useWindowDimensions();
  const isWeb = Platform.OS === 'web';
  const isTablet = width > 768;

  const styles = useMemo(() => StyleSheet.create({
    innerContainer: {
      flexDirection: (isWeb && isTablet) ? 'row' : 'column',
      alignItems: (isWeb && isTablet) ? 'flex-start' : 'center',
      gap: 10, 
      flex: 1,
      justifyContent: 'space-evenly'
    },
    container: {
      flex: 1,
      padding: 20,
      backgroundColor: '#ffffff',
      maxWidth: '100%',
      alignSelf: 'center',
      width: '100%',
    },
    photoContainer: {
      alignItems: 'center',   
      paddingVertical: 20,
    },
    photoPressable: {
      alignItems: 'center',
      margin: 5,
    },
    photoWrapper: {
      alignItems: 'center',
    },
    photoImage: {
      width: 200,
      height: 200,
      borderRadius: 100,
      borderWidth: 2,
      borderColor: stdCouleurBleu,
    },
    userName: {
      fontSize: 24,
      color: 'black',
      fontWeight: '600',
      marginTop: 15,
    },
    errorContainer: {
      backgroundColor: '#ffebee',
      borderColor: '#f44336',
      borderWidth: 1,
      borderRadius: 8,
      padding: 15,
      marginHorizontal: 0,
      marginVertical: 10,
    },
    errorText: {
      color: '#f44336',
      fontSize: 16,
      textAlign: 'center',
      fontWeight: '500',
    },
    contentContainer: {
      flexDirection: 'column',
      flex: 2,
      gap: 30,
      width: '100%',
      maxWidth: 700,
      height: '100%',
    },
    
    itemContainer: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 15,
      backgroundColor: 'white',
      padding: 15, 
      borderRadius: 12,
      borderWidth: 1,
      borderColor: '#e0e0e0',
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 3,
      minHeight: 80,
    },
    itemHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 0,
      minWidth: 200,
    },
    itemContent: {
      // flex: 1,
      // marginLeft: 0,
    },
    emailInput: {
      fontSize: 18,
      color: 'black',
      textAlign: (isWeb && isTablet) ? 'left' : 'center',
      borderBottomWidth: 1,
      borderBottomColor: '#e0e0e0',
      paddingVertical: 10,
      marginBottom: 15,
      minWidth: 'auto',
    },
    switchContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 0,
      flexWrap: 'wrap',
    },
    switchText: {
      color: 'grey',
      marginLeft: 10,
      flex: 1,
    },
    buttonContainer: {    
      minWidth: 'auto',
    },
    entiteContainer: {
      minWidth: 'auto',
    },
    entitePressable: {
      borderRadius: 8,
      backgroundColor: '#f8f9fa',
      minHeight: 50,
    },
    entiteRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 15,
      paddingHorizontal: 15,
      minHeight: 50,
    },
    entiteText: {
      fontSize: 18,
      color: 'grey',
      flex: 1,
    },
    iconContainer: {
      marginRight: (isWeb && isTablet) ? 15 : 10,
      minWidth: 30,
      alignItems: 'center',
    },
    label: {
      fontSize: 18,
      fontWeight: 'bold',
      color: stdCouleurBleu,
      marginLeft: 8,
    },
    
    scrollContainer: {
      flex: 1,
    },
    
    // Style commun pour tous les Pressable
    standardPressable: {
      paddingVertical: 15,
      paddingHorizontal: 20,
      borderRadius: 8,
      minHeight: 50,
      justifyContent: 'center',
      alignItems: 'center',
    },
    
    // Styles pour le dialog de sélection photo
    dialogOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center',
      alignItems: 'center',
    },
    dialogContainer: {
      backgroundColor: 'white',
      borderRadius: 12,
      padding: 20,
      margin: 20,
      minWidth: isWeb ? 300 : '80%',
      alignItems: 'center',
    },
    dialogTitle: {
      fontSize: 20,
      fontWeight: 'bold',
      color: stdCouleurBleu,
      marginBottom: 20,
      textAlign: 'center',
    },
    dialogOption: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 15,
      paddingHorizontal: 20,
      borderRadius: 8,
      backgroundColor: '#f8f9fa',
      marginBottom: 10,
      width: '100%',
      minHeight: 50,
    },
    dialogOptionText: {
      fontSize: 16,
      color: 'black',
      marginLeft: 10,
      width: '100%',
      alignItems: 'center',
      textAlign: 'center',
    },
    dialogCancel: {
      paddingVertical: 15,
      paddingHorizontal: 20,
      marginTop: 10,
      borderRadius: 8,
      width: '100%',
      minHeight: 50,
      justifyContent: 'center',
    },
    dialogCancelText: {
      fontSize: 16,
      color: 'red',
      textAlign: 'center',
    },
    
    // Styles pour le modal de sélection d'entité
    modalContainer: {
      flex: 1,
      backgroundColor: 'white',
      padding: 20,
      paddingTop: isWeb ? 20 : 50,
    },
    modalHeader: {
      paddingBottom: 20,
      borderBottomWidth: 1,
      borderBottomColor: '#e0e0e0',
      marginBottom: 20,
    },
    modalTitle: {
      fontSize: 24,
      fontWeight: 'bold',
      color: stdCouleurBleu,
      textAlign: 'center',
    },
    modalItem: {
      paddingVertical: 15,
      paddingHorizontal: 20,
      borderBottomWidth: 1,
      borderBottomColor: '#f0f0f0',
      minHeight: 50,
      justifyContent: 'center',
    },
    modalItemText: {
      fontSize: 18,
      color: 'grey',
      textAlign: 'center',
    },
    modalCloseButton: {
      backgroundColor: stdCouleurBleu,
      borderRadius: 8,
      paddingVertical: 15,
      paddingHorizontal: 20,
      marginTop: 20,
      minHeight: 50,
      justifyContent: 'center',
      alignItems: 'center',
    },
    modalCloseText: {
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    scrollViewContent: {
      flexGrow: 1,
    },
    logoCenter: {
      justifyContent: 'center' as const,
      alignItems: 'center' as const,
    },
    logoCenterWithMargin: {
      justifyContent: 'center' as const,
      alignItems: 'center' as const,
      marginTop: 10,
    },
    // Styles pour la gestion de documents (RIB / Signature)
    documentInfoContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: '#f8fafc',
      borderRadius: 8,
      padding: 12,
      marginBottom: 8,
      borderWidth: 1,
      borderColor: '#e2e8f0',
    },

    documentInfoContent: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },

    documentInfoText: {
      marginLeft: 12,
      flex: 1,
    },

    documentFileName: {
      fontSize: 16,
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: 2,
    },

    documentFileInfo: {
      fontSize: 12,
      color: '#6b7280',
    },

    documentActions: {
      flexDirection: 'row',
      alignItems: 'center',
    },

    documentActionButton: {
      padding: 8,
      marginLeft: 8,
      borderRadius: 6,
      backgroundColor: '#f1f5f9',
    },
    // Fichier bouton (reprise de NouvelleDemande)
    fichierContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    fichierButton: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    fichierText: {
      fontStyle: 'italic',
      paddingLeft: 8,
      color: '#6b7280',
      fontWeight: 'bold',
    },
    fichierDeleteButton: {
      padding: 4,
    },
    drawingArea: {
      width: 300,
      height: 150,
      borderWidth: 1,
      borderColor: '#e5e7eb',
      borderRadius: 8,
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'white',
      position: 'relative',
    },
    signaturePreview: {
      width: 220,
      height: 80,
      marginBottom: 8,
    },
    emptySignatureText: {
      color: '#9ca3af',
      fontStyle: 'italic',
      marginBottom: 8,
    },
  }), [width]);

  return { styles, isWeb, isTablet };
};